<script setup>
/**
 * Component for editing a patient's information
 * Takes in patient as a prop
 */
import { reactive, onMounted, computed } from 'vue';
import { editPatient } from '../firebase_files/patient_functions';
import { chronicDiseases, resetDiseaseObjects } from '@/libraries/DiseaseObjects'

const emits = defineEmits(['cancel', 'updatePatient']);
const props = defineProps(['patient'])
const state = reactive({
  patient: { cr: '' },
  patientHasDisease: false,

})
/**
 * @returns {string} selected diseases in display friendly format i.e => "AIDS, Dementia"
 */
const displayDisease = computed(() => {
  const selectedDiseases = chronicDiseases.filter((opt) => opt.isSelected)
  const names = [];
  selectedDiseases.forEach(opt => {
    names.push(opt.name)
  })
  return names.join(', ')
})

// main script
resetDiseaseObjects(); // make sure diseases are reset
state.patient = props.patient;


onMounted(() => {
  document.querySelector('#patient-cr-code').focus();
})


function onEnterKey() {
  submitPatient();
}

async function submitPatient() {
  const result = await editPatient(state.patient);
  if (!result) {
    alert('Error editing patient');
    return;
  } else {
    emits('updatePatient', state.patient); // updates patient
    emits('cancel'); // closes model
  }
  
}

function cancel() {
  emits('cancel')
}

function toggle(option) {
  option.isSelected = !option.isSelected;
}
</script>
<template>
  <div class="modal">
    <div class="modal-content" v-on:keyup.enter="onEnterKey">

      <div class="modal-top">
        <div class="title">
          <span>Edit Patient</span>
        </div>
        <div class="close" @click="cancel()">
          <i class="fa fa-times"></i>
        </div>
      </div>

      <div class="form-item">
        <label>Patient ID</label>
        <input v-model="state.patient.cr" id="patient-cr-code">
      </div>



      <div class="form-item">
        <label>Full Name</label>
        <input v-model="state.patient.name" id="patient-name">
      </div>
      <div class="form-item">
        <label>Date of Birth</label>
        <input type="date" v-model="state.patient.dateOfBirth">
      </div>
      <div class="form-item">
        <label>DISEASE/COMORBIDITY?</label>
        <input v-model="state.patientHasDisease" type="checkbox">
      </div>
      <div id="disease-selection" v-if="state.patientHasDisease">
        <div class="form-item"><label>Disease Selection</label>
          <div>{{ displayDisease }}</div>
        </div>
        <div id="disease-list">
          <div v-for="(opt) in chronicDiseases" :key="opt" @click="toggle(opt)" :class="{ selected: opt.isSelected }">
            {{ opt.name }}
          </div>
        </div>
      </div>

      <div class="buttons" >
        <div class="right">
          <button @click="submitPatient()" class="primary">
            Update Patient
          </button>
        </div>
      </div>


    </div>
  </div>
</template>
<style scoped lang="scss">
.modal-content {
  width: 46.5rem;
}

.my-form-item {
  display: flex;

  label {
    padding-top: 10px;
  }

  input {
    flex: 1;
    margin: 0 15px;
  }
}


#disease-selection {

  #disease-list {
    max-height: 250px;
    overflow-y: scroll;
  }


  label {
    margin-left: auto;
    margin-right: auto;
  }

  .selected {
    background-color: aqua;
  }

}

div.buttons {
  display: flex;
  text-align: right;

  .left {
    flex: 1;
  }
}
</style>